import { Injectable }               from '@angular/core';
import { Http }                     from '@angular/http';
import { ISortableFilter }          from './../common/sortable-filter';
import { Globals }                  from './../common/globals';
import { AuthHttp }                 from 'angular2-jwt';
import { Observable }               from 'rxjs/Observable';
import { CommonService }            from './common.service';
import { DynamicReportFilter }      from './../monitoring/dynamic-report-filter';
import { MatSnackBar }               from '@angular/material';

@Injectable()
export class ReportingService {

    private _commonService: CommonService;

    constructor(public authHttp: AuthHttp, private http: Http, private globals: Globals, public snackbar: MatSnackBar) {
        this._commonService = new CommonService(authHttp, http, globals, 'reporting', snackbar);
    }

    public listReports(): Observable<any> {
        return this._commonService.get('ListReports');
    }

    public runReport(params: DynamicReportFilter): Observable<any> {
        return this._commonService.post('RunReport', params);
    }

    public getItems(filter: ISortableFilter): Observable<any> {
        return this._commonService.getItems(filter);
    }

    public insertItem(item: any): Observable<any> {
        return this._commonService.insertItem(item);
    }

    public updateItem(id: string, item: any): Observable<any> {
       return this._commonService.updateItem(id, item);
    }

    public deleteItem(id: string): Observable<any> {
        return this._commonService.deleteItem(id);
    }

    public pdf(filter: DynamicReportFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.pdf(filter, columnParams, pageOrientation);
    }

    public csv(filter: DynamicReportFilter, columnParams: Array<any>, pageOrientation: string = null) {
        this._commonService.csv(filter, columnParams, pageOrientation);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/reporting.service.ts